import React from 'react'
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
import { complement } from 'ramda'
import { connectedReduxRedirect } from 'redux-auth-wrapper/history3/redirect'
import { routerActions } from 'react-router-redux'
import { Dimmer, Loader } from 'semantic-ui-react'
import { getIsAuthenticating, getIsAuthenticated } from 'store/selectors'

const LoadingScreen = () => (
  <Dimmer page active inverted>
    <Loader />
  </Dimmer>
)

const locationHelper = locationHelperBuilder({})

export const UserIsAuthenticated = connectedReduxRedirect({
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/login',
  allowRedirectBack: true,
  authenticatedSelector: getIsAuthenticated,
  authenticatingSelector: getIsAuthenticating,
  AuthenticatingComponent: LoadingScreen,
  wrapperDisplayName: 'UserIsAuthenticated',
  redirectAction: routerActions.replace
})

export const UserIsNotAuthenticated = connectedReduxRedirect({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  allowRedirectBack: false,
  AuthenticatingComponent: LoadingScreen,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/',
  authenticatedSelector: complement(getIsAuthenticated),
  authenticatingSelector: getIsAuthenticating,
  redirectAction: routerActions.replace
})



// WEBPACK FOOTER //
// ./src/utils/RouteGuards.js